var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-filter-input"},[_c('i',{staticClass:"el-icon-search"}),_c('input',{attrs:{"type":"text","placeholder":"Фильтр"},domProps:{"value":_vm.value},on:{"input":_vm.handlerInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }